import React from 'react';
import { motion } from 'framer-motion';
export function PromiseSection() {
  return <section className="w-full bg-white px-4 md:px-6 py-6 md:py-24 text-center" data-id="element-285">
      <div className="max-w-3xl mx-auto" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-287">
          <h2 className="font-['Playfair_Display'] text-2xl md:text-4xl lg:text-5xl font-bold text-[#2D2D2D] mb-4 md:mb-10" data-id="element-288">
            Imagina que{' '}
            <span className="text-[#E8734A]" data-id="element-289">mañana por la mañana:</span>
          </h2>

          <div className="space-y-3 md:space-y-6 mb-5 md:mb-12 text-left" data-id="element-290">
            <div className="bg-[#FFF8F0] rounded-xl p-5 md:p-8 border-l-4 border-[#D4A853] shadow-sm" data-id="element-291">
              <p className="text-lg text-[#2D2D2D] leading-relaxed text-center" data-id="element-292">
                Te sientas frente a tu laptop, haces{' '}
                <span className="text-[#D4A853] font-bold" data-id="element-293">60 segundos</span> de
                un ejercicio simple que aprendiste esta tarde, y sientes cómo tu
                cerebro cambia de canal.
              </p>
              <p className="text-xl text-[#E8734A] font-bold mt-3 md:mt-4 text-center" data-id="element-294">
                De "tengo mil cosas pendientes" a "sé exactamente qué hacer y
                estoy lista para hacerlo".
              </p>
            </div>

            <div className="bg-[#FFF8F0] rounded-xl p-5 md:p-8 border-l-4 border-[#D4A853] shadow-sm" data-id="element-295">
              <p className="text-lg text-[#2D2D2D] leading-relaxed text-center" data-id="element-296">
                En los siguientes{' '}
                <span className="text-[#D4A853] font-bold" data-id="element-297">20 minutos</span>{' '}
                escribes el mejor post que has escrito en meses.{' '}
                <span className="font-bold" data-id="element-298">Fluye.</span> Las palabras salen
                solas. Conectas con tus clientes desde un lugar de claridad que
                ellos van a notar.
              </p>
            </div>

            <div className="bg-[#FFF8F0] rounded-xl p-5 md:p-8 border-l-4 border-[#D4A853] shadow-sm" data-id="element-299">
              <p className="text-lg text-[#2D2D2D] leading-relaxed text-center" data-id="element-300">
                A las{' '}
                <span className="text-[#D4A853] font-bold" data-id="element-301">3 de la tarde</span>,
                cuando normalmente sientes que alguien te apagó el interruptor,
                usas otro truco de{' '}
                <span className="text-[#D4A853] font-bold" data-id="element-302">60 segundos</span> y{' '}
                <span className="font-bold text-[#E8734A]" data-id="element-303">
                  recuperas la chispa
                </span>{' '}
                sin tomar más café.
              </p>
            </div>

            <div className="bg-[#FFF8F0] rounded-xl p-5 md:p-8 border-l-4 border-[#D4A853] shadow-sm" data-id="element-304">
              <p className="text-lg text-[#2D2D2D] leading-relaxed text-center" data-id="element-305">
                Al final del día, cierras la laptop sabiendo exactamente qué
                lograste. Y tienes{' '}
                <span className="font-bold text-[#E8734A]" data-id="element-306">energía real</span>{' '}
                para estar con tus hijos.
              </p>
              <p className="text-xl text-[#2D2D2D] font-bold mt-3 md:mt-4 text-center" data-id="element-307">
                No el cuerpo presente con la mente en otro lado. Tú de verdad,
                ahí.
              </p>
            </div>
          </div>

          <div className="bg-[#2D2D2D] text-white rounded-xl p-5 md:p-10 shadow-lg" data-id="element-308">
            <p className="text-2xl font-['Playfair_Display'] font-bold leading-relaxed" data-id="element-309">
              Eso no es un sueño. Es lo que pasa cuando dejas de trabajar contra
              tu biología y{' '}
              <span className="text-[#D4A853]" data-id="element-310">
                empiezas a trabajar con ella.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}